import React from 'react';
import { Alert } from '@mui/material';
import { styled, withTheme } from '@mui/styles';

const DefaultAlert = styled(withTheme(Alert))(({ theme }) => ({
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.grey[50],
  fontSize: 'inherit',
}));

export default function AlertAlt({ severity, children, ...rest }) {
  if (severity === 'default') {
    return <DefaultAlert {...rest}>{children}</DefaultAlert>;
  }

  return <Alert {...{ severity, ...rest }}>{children}</Alert>;
}
